module.exports = __webpack_public_path__ + "img/palestine.6c56f3c4.svg";